// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';
export const API_UPLOAD_URL = import.meta.env.VITE_API_BASE_URL + '/files/';

export const API_TIMEOUT = 30000;

// App Configuration
export const APP_NAME = 'てらびより';
export const APP_VERSION = '1.0.0';

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// Date formats
export const DATE_FORMAT = 'YYYY/MM/DD';
export const DATETIME_FORMAT = 'YYYY/MM/DD HH:mm';
export const TIME_FORMAT = 'HH:mm';

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info',
  MENU_TYPE: 'menuType',
  THEME: 'theme',
  LANGUAGE: 'language',
  SIDEBAR_COLLAPSED: 'sidebar_collapsed',
} as const;

export enum MenuType {
  A1 = 'A1',
  A2 = 'A2',
}
export enum TypeUpLoad {
  AVATAR = '0',
  POST = '1',
}

export enum RoleType {
  SUPER_ADMIN = 0, // スーパー管理者 - Super Administrator
  TEMPLE_ADMIN = 1, // お寺管理者 - Temple Administrator
  BRANCH_MANAGER = 2, // 拠点管理者 - Branch Manager
  STAFF_MANAGER = 3, // 一般職員管理者 - Staff Manager
  EXPERT = 4, // 専門家 - Expert/Specialist
}

// Plan mapping: 0 = Free, 1 = Standard, 2 = Premium
export const PLAN_NAMES: Record<string, string> = {
  '0': '無料',
  '1': 'スタンダード',
  '2': 'プレミアム',
};

// Role labels for system-wide usage
export const ROLE_LABELS: Record<number, string> = {
  0: 'スーパー管理者', // Super Administrator
  1: 'お寺管理者', // Temple Administrator
  2: '拠点管理者', // Branch Manager
  3: '一般職員管理者', // Staff Manager
  4: '専門家', // Expert/Specialist
};

// Route paths
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CONTENT: '/content',
  COURSES: '/courses',
  RESERVATIONS: '/reservations',
  DEVICES: '/devices',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  ROLE_SELECTION_PAGE: '/select-role',
} as const;

export const MESSAGES = {
  SUCCESS: {
    CREATED: '登録しました。',
    UPDATED: '変更しました。',
    DELETED: '削除しました。',
    CANCELED: 'キャンセルしました。',
    RESERVED: '予約が完了しました。',
    EMAIL_SENT: 'メールは正常に送信されました。',
  },
  ERROR: {
    NO_DATA: '該当する情報はありません。',
  },
} as const;

export const CONFIRM_MESSAGES = {
  DELETE: '削除してもよろしいですか？',
  BACK: '入力中の内容は保存されていません。移動してもよろしいですか?',
  CREATE: 'この内容で登録します。よろしいですか？',
  UPDATE: 'この内容で更新します。よろしいですか？',
};

export const DIALOG_TITLES = {
  CONFIRM: '確認ダイアログ',
};

// Target type options for notification
export const TARGET_TYPE_OPTIONS = [
  { value: '0', label: '全体' },
  { value: '1', label: '' }, // Chưa có text cho giá trị 1
  { value: '2', label: '事業所' },
  { value: '3', label: '拠点' },
];

export const RELATIONSHIP_TYPE_OPTIONS: Record<string, string> = {
  '0': '配偶者',
  '1': '子',
  '2': '兄弟姉妹',
  '3': '孫',
  '4': 'その他',
};

